import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Utils } from '../../utils';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ItemsService {
    public selectedItems: Array<any> = <any>[];
    public selectedProhibitedItems: Array<any> = <any>[];
    public selectedRestrictedItems: Array<any> = <any>[];
    public cityId: number;
    public couponCode: string;
    public itemValue: number;
    public recipient: any;
    public selectedSuite: string;
    constructor(
        private http: HttpClient
    ) { }

    getItems(suiteCode) {
        return this.http.get<any[]>(`${environment.apiUrl}/items/getitems/${suiteCode}`);
    }

    validateCoupon(data) {
        return this.http.post(`${environment.apiUrl}/items/validatecoupon`, data,
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            });
    }

    createPackage(data) {
        return this.http.post<any[]>(`${environment.apiUrl}/items/createpackage`, data,
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            });
    }

    verifyAddress(data) {
        return this.http.post(`${environment.apiUrl}/items/verifyaddress`, data,
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            });
    }

    returnRequest(data) {
        return this.http.post(`${environment.apiUrl}/items/returnrequest`, data,
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            });
    }

    returnRequestForPrepaidLabel(data) {
        return this.http.post(`${environment.apiUrl}/items/returnrequestforprepaidlabel`, data,
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            });

    }

    uploaddoc(data, id) {
        return this.http.post(`${environment.apiUrl}/items/uploaddoc/${id}`, data,
            {
                headers: new HttpHeaders({
                    //"Content-Type": "application/json"
                }), reportProgress: true, observe: 'events'
            });
    }

    uploadtest(data) {
        return this.http.post(`${environment.apiUrl}/items/uploadtest`, data,
            {
                headers: new HttpHeaders({
                    //"Content-Type": "application/json"
                }), reportProgress: true, observe: 'events'
            });
    }

    getUsStates() {
        return this.http.get('api/us-states');
    }

    resetAllData() {
        this.selectedProhibitedItems = [];
        this.selectedRestrictedItems = [];
        this.selectedItems = [];
        this.recipient = null;
        this.itemValue = null;
        this.couponCode = null;
        this.cityId = null;
    }

    createPictureRequest(data) {
        return this.http.post(`${environment.apiUrl}/items/createpicturerequest`, data,
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            });
    }

    validateCashOnDelivery(data) {
        return this.http.post(`${environment.apiUrl}/items/validatecashondelivery`, data,
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            });

    }

    verifyAuthorizeNetPayment(orderId, transId) {
        const data = { orderId: orderId, transactionId: transId };
        return this.http.post(`${environment.apiPaymentUrl}/payment/verifyauthorizenetpayment`, data,
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            });

    }

    //list special request
    //GetSpecialRequestList
    getSpecialRequestList() {
        return this.http.get(`${environment.apiUrl}/items/getspecialrequestlist`);
    }

    //CreateSpecialRequest
    createSpecialRequest(data) {
        return this.http.post(`${environment.apiUrl}/items/createspecialrequest`, data,
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            });
    }

    //CancelSpecialRequest
    cancelSpecialRequest(id) {
        return this.http.post(`${environment.apiUrl}/items/cancelspecialrequest/${id}`, {},
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            });
    }
}